<div class="w-full h-full flex flex-row items-stretch" #container sticky
    (sticky)="container.active = $event; onHeaderStickyChange($event)" [top]="0.0001">
    <div class="w-full  flex flex-row items-center justify-center transition-all duration-500 ease-expo mx-auto z-20"
        [ngClass]="container.active ? activeContainerClasses() : ''">
        <div class="w-full  flex flex-col items-stretch"  [ngClass]="{'rounded-lg border border-zen-neutralp90': !container.active}">
            <div  [ngClass]="{'px-4 shadow-Small': !container.active}"
                class="flex h-20 bg-white  py-4 flex-row items-center justify-between w-full max-w-[100rem] min-w-[48rem] mx-auto transition-all duration-500 ease-expo rounded-lg">
                <ng-content select="[left]"></ng-content>
                <ng-content></ng-content>
                <ng-content select="[right]"></ng-content>
            </div>
            <div class="flex flex-row items-center w-full max-w-[100rem] min-w-[48rem] mx-auto">
                <ng-content select="[extra]"></ng-content>
            </div>
        </div>
    </div>

    @if (container.active) {
    <div class="h-20"></div>
    }
</div>